import React from "react";
import { Link } from "react-router-dom";

export const Client = ({ client }) => (
  <tr className=" text-white text-center w-4/5 justify-center items-center text-xl h-14 border-2">
    <td className="text-[#eed495]">{client.name}</td>
    <td>{client.contact}</td>
    <td>{client.email}</td>
    <td className="text-[#eed495]">{client.membership}</td>
    <td className="text-[#eed495]">{client.balance}</td>
    <td className="hover:text-[#eed495] text-6xl">
      <Link className="mx-4" to={`/clients/${client.id}`}>
        &middot;&middot;&middot;
      </Link>
    </td>
  </tr>
);
